var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Pages/components/Schedule.tsx
import React, { useCallback, useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import icons from "../../utils/Icons";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import Spinner from "../../components/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import useFetchTimeLogs from "../../hooks/useFetchTimeLogs";
import AddTimeLogs from "../../components/modals/AddTimeLogs";
import CustomDayTimeLog from "./time_log/CustomDayTimeLog";
import AgendaEventTimeLog from "./time_log/TimeLogAgendaEvent";
var localizer = momentLocalizer(moment);
var TimeLogs = function () {
    var chaseListNavigate = useChaseListNavigate();
    var _a = useFetchTimeLogs(), events = _a.events, loading = _a.loading, error = _a.error, fetchTimeLogs = _a.fetchTimeLogs, positions = _a.positions;
    var _b = useState([]), calendarEvents = _b[0], setCalendarEvents = _b[1];
    var _c = useState("month"), view = _c[0], setView = _c[1];
    var _d = useState(new Date()), date = _d[0], setDate = _d[1];
    var _e = useState(false), showAddLogModal = _e[0], setShowAddLogModal = _e[1];
    var getTimeLogs = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchTimeLogs()];
                case 1:
                    _a.sent();
                    if (error) {
                        toast.error(error);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSelectSlot = useCallback(function (_a) {
        var start = _a.start, end = _a.end;
        console.log(start);
        console.log(end);
    }, []);
    useEffect(function () {
        if (events.length > 0) {
            console.log("geting events", events);
            var calendarEvents_1 = events.map(function (event) {
                return {
                    start: new Date(event.start),
                    end: new Date(event.end),
                    title: event.title,
                    content: event.content,
                    class: event.class,
                    id: event.id,
                };
            });
            setCalendarEvents(calendarEvents_1);
        }
        else {
            setCalendarEvents([]);
        }
    }, [events]);
    useEffect(function () {
        getTimeLogs();
    }, []);
    var BackHandle = function () {
        chaseListNavigate("/");
    };
    var handleDateClick = function (date) {
        setView("agenda");
        setDate(date);
    };
    return (_jsxs("div", { children: [_jsx(ToastContainer, { position: "top-right" }), _jsx(PageHeader, { pageTitle: "Time Logs", backTitle: "Home", backAction: BackHandle }), showAddLogModal && (_jsx(AddTimeLogs, { positions: positions, addLogHandle: function () {
                    getTimeLogs();
                    setShowAddLogModal(false);
                }, closeModal: function () { return setShowAddLogModal(false); } })), !showAddLogModal && (_jsx("button", { onClick: function () { return setShowAddLogModal(true); }, className: "fixed top-36 right-6 z-10 rounded-full shadow-md bg-[#4bb981] w-[40px] h-[40px] flex items-center justify-center", children: _jsx("img", { src: icons.plus, alt: "Add Button" }) })), loading ? (_jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) })) : (_jsx("div", { className: "p-4 overflow-y-auto mb-[80px]", children: _jsx(Calendar, { views: ["month", "agenda"], localizer: localizer, events: calendarEvents, startAccessor: "start", endAccessor: "end", style: { height: view === "month" ? 450 : 500 }, view: view, date: date, selectable: true, onNavigate: function (newDate) {
                        setDate(newDate);
                    }, onView: function (newView) {
                        setView(newView);
                    }, components: {
                        month: {
                            dateHeader: function (props) { return (_jsx(CustomDayTimeLog, { date: props.date, events: calendarEvents, onClick: function () {
                                    return handleDateClick(props.date);
                                } })); },
                            event: function () { return null; }, // Hide default event layout
                        },
                        agenda: {
                            event: function (props) { return (_jsx(AgendaEventTimeLog, { event: props.event, onDelete: function (message) {
                                    toast.success(message);
                                    getTimeLogs();
                                    console.log("deleted, getting fresh logs");
                                } })); },
                        },
                    }, messages: { agenda: "Time Logs" } }) }))] }));
};
export default TimeLogs;
